/*
 * Product thumbnail pagination — Classic Whimsy custom code.
 *
 * Shows 8 thumbnails (2 rows of 4) at a time on desktop, with prev/next
 * controls to page through the rest. Enhances the stock thumbnail list
 * without modifying media-gallery.js; loaded via a Custom Liquid block on
 * the product template. Below the desktop breakpoint it does nothing and
 * the stock thumbnail behaviour is left untouched.
 */
(function () {
  var PER_PAGE = 8;
  var DESKTOP = window.matchMedia('(min-width: 1024px)');

  function paginate(wrap) {
    if (wrap.dataset.thumbPager === 'ready') return;
    var list = wrap.querySelector('.media-thumbs');
    if (!list) return;

    var items = Array.prototype.slice.call(
      list.querySelectorAll('.media-thumbs__item')
    );
    if (items.length <= PER_PAGE) return; // nothing to page through

    wrap.dataset.thumbPager = 'ready';
    var pages = Math.ceil(items.length / PER_PAGE);
    var page = 0;

    var controls = document.createElement('div');
    controls.className = 'thumb-pagination__controls';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'thumb-pagination__btn thumb-pagination__btn--prev';
    prev.setAttribute('aria-label', 'Previous thumbnails');
    prev.innerHTML = '&lsaquo;';

    var status = document.createElement('span');
    status.className = 'thumb-pagination__status';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'thumb-pagination__btn thumb-pagination__btn--next';
    next.setAttribute('aria-label', 'Next thumbnails');
    next.innerHTML = '&rsaquo;';

    controls.appendChild(prev);
    controls.appendChild(status);
    controls.appendChild(next);
    wrap.appendChild(controls);

    function render() {
      if (!DESKTOP.matches) {
        // Desktop-only feature: hand control back to the stock strip.
        items.forEach(function (it) { it.classList.remove('thumb-paged-out'); });
        controls.hidden = true;
        return;
      }
      controls.hidden = false;
      var start = page * PER_PAGE;
      var end = start + PER_PAGE;
      items.forEach(function (it, i) {
        it.classList.toggle('thumb-paged-out', i < start || i >= end);
      });
      status.textContent = (page + 1) + ' / ' + pages;
      prev.disabled = page === 0;
      next.disabled = page === pages - 1;
    }

    prev.addEventListener('click', function () {
      if (page > 0) { page -= 1; render(); }
    });
    next.addEventListener('click', function () {
      if (page < pages - 1) { page += 1; render(); }
    });
    DESKTOP.addEventListener('change', render);

    render();
  }

  function init() {
    document.querySelectorAll('.media-gallery__thumbs').forEach(paginate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
